import { Component, h } from '@stencil/core';

@Component({
  tag: 'pc-generic-error',
  shadow: true,
})
export class PcGenericError {
  render() {
    return <pc-error-card slot="error-card" statusLabel="Oops, something went wrong. Please try again later." showEditCartLink={false} />;
  }
}
